import { render, staticRenderFns } from "./HazardInspectionList.vue?vue&type=template&id=10239be2&scoped=true"
import script from "./HazardInspectionList.vue?vue&type=script&lang=js"
export * from "./HazardInspectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10239be2",
  null
  
)

export default component.exports